var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"0px","height":"0px"}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }